import { observer } from "mobx-react-lite";
import { TestRun } from "models/test-run";
import TestSelectionInfo from "./test-selection-info";

interface Props {
  testRun: TestRun;
}

const TestSelectionTab = observer(({ testRun }: Props) => {
  return (
    <div className="test-selection-tab">
      <TestSelectionInfo testRunId={testRun.id} />
    </div>
  );
});

export default TestSelectionTab;
